import { render, staticRenderFns } from "./settings-icon.vue?vue&type=template&id=61c1af91&"
import script from "./settings-icon.vue?vue&type=script&lang=js&"
export * from "./settings-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports